import {
  Component,
  Output,
  EventEmitter,
  Input,
  ChangeDetectionStrategy,
  ViewEncapsulation,
  OnInit,
  inject
} from "@angular/core";
import { environment } from "environments/environment";
import { AuthService } from "@shared/auth/auth.service";
import { MsalBroadcastService } from "@azure/msal-angular";
import { filter} from "rxjs/operators";
import { EventMessage, EventType } from "@azure/msal-browser";
import { Subscription} from "rxjs";
import { SharedService } from "@shared/services/shared.service";

@Component({
  selector: "app-navbar",
  host: {
    class: "matero-header",
  },
  templateUrl: "./navbar.component.html",
  styleUrls: ["./navbar.component.scss"],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.Default,
})
export class NavbarComponent implements OnInit {
  public titleFull = "Indoor Clean Air Act - Tobacco Prevention and Education Program";
  public titleTablet = "Indoor Clean Air Act - Tobacco Prevention and Education Program";
  public titleMobile = "Indoor Clean Air Act";
  subscription !: Subscription;
  public environment = environment;
  @Input() showToggle = true;
  @Output() toggleSidenav = new EventEmitter<void>();

  private authService = inject(AuthService);
  public sharedService = inject(SharedService);
  private msalBroadcastService =  inject(MsalBroadcastService);

  ngOnInit(): void{
    this.msalBroadcastService.msalSubject$
    .pipe(
      filter((msg: EventMessage) => msg.eventType === EventType.LOGIN_SUCCESS)
    )
    .subscribe(() => {
      this.toggleSidenav.emit();
    });

    if(this.authService.isAuthenticated()) {
      this.authService.loadUserInformation();
      
      this.sharedService.getUserTheme();
    }
  }

  public get username(): string{
    return this.authService.username
  }

  login() {
    this.authService.login();
  }

  isAuthenticated(): boolean {
    return this.authService.isAuthenticated();
  }

  logout() {
    this.authService.logout();
  }

  toggleTheme() {
    this.sharedService.darkMode = !this.sharedService.darkMode;
    this.sharedService.theme = this.sharedService.darkMode ? "dark" : "light";
    if(this.isAuthenticated()){
      this.sharedService.updateUserTheme();
    }
    this.sharedService.toggleTheme();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
